import { Injectable } from '@angular/core';
import { global } from '../../models/global';
import { Observable } from 'rxjs/Observable';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';

@Injectable({
  providedIn: 'root'
})

export class DSCostApprovalService {

  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  GetCostApproval(PageNo : Number,region: any, rmh: any, requirmentType: any, product: any, crop: any, userId: any, status: any, whCode:any,isProduct:any,year:any): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/GetCostApproval';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = {"PageNo" :PageNo ,"userId": userId, "product": product, "rmh": rmh, "region": region, "crop": crop, "requirementType": requirmentType, "status":status, "whCode": whCode ,"isProduct":isProduct,"year":year};
    debugger;
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  SaveCostApproval(data: any, userId: any, requirmentType: any, year:any): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/SaveCostApproval';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "objData": { "approvalList": data, "userId": userId, "requirementType": requirmentType, "year": year} };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  DownloadExcel(userId: string, requirmentType: string, rmh:string, product:string,whCode:string,status:string,year:number): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/DownloadExcel';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    //let body = { "userId": userId, "requirementType": requirmentType, 'rmh':rmh  };
    let body = { "userId": userId, "product": product, "rmh": rmh,  "requirementType": requirmentType, "status":status, "whCode": whCode,"year":year };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }

  UploadDocument(documents: File, UserId: string, year:any,AnnualCycle:any): Observable<any> {
    debugger;
    const formData = new FormData();
    formData.append("file", documents);
    formData.append("UserId", UserId);
    formData.append("year", year);
    formData.append("AnnualCycle", AnnualCycle);
    let headers = new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/CostApproval/UploadFiles",
      headers: headers,
      body: formData
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res.json();
      });
  }

  DownloadExcelForAdmin(userId: string, requirmentType: string,rmh:string, product:string,whCode:string,status:string,year:number,sbu:string,division:string,zone:string,region:string,crop:string ): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/DownloadExcelCropwiseForAdmin';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "userId": userId, "requirementType": requirmentType,"product": product, "rmh": rmh,"status":status, "whCode": whCode,"year":year,"sbu":sbu,"division":division,"zone":zone,"region":region,"crop":crop };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  DownloadExcelCropwise(userId: string, requirmentType: string, rmh:string, product:string,whCode:string,status:string,year:number): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/DownloadExcelCropwise';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    //let body = { "userId": userId, "requirementType": requirmentType, 'rmh':rmh  };
    let body = { "userId": userId, "product": product, "rmh": rmh,  "requirementType": requirmentType, "status":status, "whCode": whCode,"year":year };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  DownloadExcelCropwiseForAdmin(userId: string, requirmentType: string,year:number ): Observable<any> {
    let url = this.ROOT_URL + '/api/CostApproval/DownloadExcelCropwiseForAdmin';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let body = { "userId": userId, "requirementType": requirmentType,"year":year  };
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
      responseType: ResponseContentType.Blob
    })
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
}